import * as React from 'react'
import { Dollars } from '@local/do-secundo-dollars'

export interface PriceTransparencyDisplayProps {
  price: number
}

export const PriceTransparencyDisplay = ({
  price
}: PriceTransparencyDisplayProps) => {
  const competitorPrice = Math.floor(1.3 * price)

  return (
    <div className='flex gap-1'>
      <Dollars amount={price} />
      <div>{`$${competitorPrice}`}</div>
    </div>
  )
}
